import React from "react";
import { useSnackbar } from "notistack";
import { Box, Card, CircularProgress, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { RecordNotFound } from "../../components/_dashboard/programmes";
import { programmesListing } from "../../DAL/Programmes/Programmes";
import CustomPopover from "src/components/CustomPopover";
import { s3baseUrl } from "src/config/config";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const ProgrammesImgStyle = styled("img")({
  top: 0,
  width: "100%",
  height: "auto",
  objectFit: "cover",
});

export default function VidoeLibrary() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { data: programmesData = [], isLoading } = useQuery({
    queryKey: ["videosLibraryProgrammes"],
    queryFn: async () => {
      const result = await programmesListing();
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) =>
      result?.program?.program?.filter((item) => item?._id !== null) || [],
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  const handleNavigateDetail = (value) => {
    navigate(`/videos-library/${value?._id?._id}`, {
      state: value,
    });
  };

  const MENU_OPTIONS = [
    {
      label: "View Details",
      icon: "bx:detail",
      handleClick: handleNavigateDetail,
    },
  ];

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h2>Videos Library Programmes</h2>
        </div>
        {programmesData.length > 0 ? (
          <>
            {programmesData.map((programm) => (
              <div className="col-md-4 col-12 mt-4">
                <Card
                  className="programm-card secondary-background"
                  sx={{
                    cursor: "pointer",
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      cursor: "pointer",
                    }}
                  >
                    <div className="col-2 programmes-menu-option">
                      <CustomPopover menu={MENU_OPTIONS} data={programm} />
                    </div>
                    <ProgrammesImgStyle
                      onClick={() => handleNavigateDetail(programm)}
                      alt={programm?.title}
                      src={
                        s3baseUrl + programm?._id?.program_images?.thumbnail_2
                      }
                    />
                  </Box>
                  <Stack
                    spacing={2}
                    className="programme-content"
                    onClick={() => handleNavigateDetail(programm)}
                  >
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: programm?.title,
                      }}
                    ></h3>
                    <p className="programme-card-desc mb-4">
                      {programm?._id?.short_description}
                    </p>
                  </Stack>
                </Card>
              </div>
            ))}
          </>
        ) : (
          <>
            <RecordNotFound title="Videos" />
          </>
        )}
      </div>
    </div>
  );
}
